// extracted by mini-css-extract-plugin
export default {"fill-placeholder-child":"fill-placeholder-child_bRXCq","prices":"prices_MPjzz"};